import React, { useRef } from 'react';
import { useCorrectedTotalsSummary } from '../../hooks/api/correctedTotals';
import BiddingOverviewTabPropsInterface from '../../types/BiddingOverviewTabProps.interface';
import TableGridItem from '../UI/TableGridItem';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { ColorizedNameRenderer, CorrectedTotalsStatusCellRenderer } from '../../utils/agGridUtils';
import { EMPTY_VALUE } from '../../types/CorrectedTotalSummary';

export default function CorrectedTotalsTab({ columnDefs, date }: BiddingOverviewTabPropsInterface) {
    const gridRef = useRef(null);
    const { data: CorrectedTotals } = useCorrectedTotalsSummary({ date });

    return (
        <TableGridItem
            ref={gridRef}
            defaultColDef={
                {
                    editable: true,
                    filter: true,
                    sortable: true,
                } as ColDef
            }
            columnDefs={columnDefs}
            rowData={CorrectedTotals}
            groupDisplayType={'groupRows'}
            groupDefaultExpanded={-1}
            groupLockGroupColumns={-1}
            groupRowRendererParams={{
                innerRenderer: ({ value, node }: ICellRendererParams) => {
                    return node.field === 'released'
                        ? CorrectedTotalsStatusCellRenderer({ value })
                        : ColorizedNameRenderer({ value, emptyValue: EMPTY_VALUE });
                },
                suppressCount: true,
                emptyValue: EMPTY_VALUE,
            }}
            suppressMakeColumnVisibleAfterUnGroup={true}
        ></TableGridItem>
    );
}
